import { render, staticRenderFns } from "./ViewPatients.vue?vue&type=template&id=1cfd62d0&scoped=true&"
import script from "./ViewPatients.vue?vue&type=script&lang=js&"
export * from "./ViewPatients.vue?vue&type=script&lang=js&"
import style0 from "./ViewPatients.vue?vue&type=style&index=0&id=1cfd62d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd62d0",
  null
  
)

export default component.exports